import { ThemeVariants } from 'src/types'
import { useThemeContext } from 'src/contexts'
import { useLocales } from 'src/contexts'

export const useSettingToggleTheme = () => {
  const { theme, handleSetTheme } = useThemeContext()
  const { translations } = useLocales()

  const isChecked = theme === ThemeVariants.DARK

  const onCheckedChange = (checked: boolean): void => {
    const newTheme = checked ? ThemeVariants.DARK : ThemeVariants.LIGHT

    handleSetTheme(newTheme)
  }

  return {
    isChecked,
    onCheckedChange,
    themeLabel: translations.setting.darkMode,
    handleSetTheme,
  }
}
